<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("require-get-survey.title") }}
                </p>
            </header>
            <section class="modal-card-body">
                <p>
                    {{
                        $t("require-get-survey.action-title", {
                            title: action.title,
                        })
                    }}
                </p>
                <div class="field">
                    <label class="label"
                        >{{ $t("require-get-survey.survey-code") }}:</label
                    >
                    <div class="control">
                        <input type="text" class="input" v-model="answer" />
                    </div>
                    <p v-if="haveError" class="help is-danger">{{ error }}</p>
                </div>
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button
                    class="button"
                    @click="save"
                    :class="{ 'is-loading': loading }"
                >
                    <Icon
                        name="fa-paper-plane"
                        helperClass="has-text-primary"
                    />
                    <span> {{ $t("require-get-survey.send") }}</span>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "require-text",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            answer: "",
            loading: false,
            error: null,
        };
    },
    computed: {
        ...mapGetters("conference", ["getConferenceId"]),
        haveError() {
            return this.error !== null;
        },
    },
    methods: {
        ...mapActions("actions", ["setActionAnswer"]),
        async save() {
            if (this.answer === "") {
                return;
            }

            this.loading = true;
            this.error = null;
            let exist = await this.checkExistsSurvey();

            if (exist) {
                let actionResult = this.action;
                actionResult.answer = this.answer;
                this.setActionAnswer(actionResult);

                let roomId = this.getConferenceId;
                this.$emit("answered", {
                    socketName: "SendGetSurveyActionAnswer",
                    roomId: roomId,
                    actionId: this.action.id,
                    answer: this.answer,
                    type: this.action.type,
                });
                this.answer = "";
            } else {
                this.error = this.$t("require-get-survey.not-found");
            }
            this.loading = false;
        },
        async checkExistsSurvey() {
            try {
                let response = await RepositoryFactory.integration.existSurvey({
                    surveyId: this.answer,
                });

                return response.data;
            } catch {
                return false;
            }
        },
    },
};
</script>